export const REQUEST_DOMAIN_STATE = 'REQUEST_DOMAIN_STATE';
export const RECEIVE_DOMAIN_STATE = 'RECEIVE_DOMAIN_STATE';
export const BLOCKED_DOMAIN = 'BLOCKED_DOMAIN';
export const REQUEST_DOMAIN_OWNER = 'REQUEST_DOMAIN_OWNER';
export const RECEIVE_DOMAIN_OWNER = 'RECEIVE_DOMAIN_OWNER';
export const REQUEST_DOMAIN_COST = 'REQUEST_DOMAIN_COST';
export const RECEIVE_DOMAIN_COST = 'RECEIVE_DOMAIN_COST';
export const CLEAR_DOMAIN_STATE = 'CLEAR_DOMAIN_STATE';
